const roleService = {
  getAvailableRoles () {
    return [
      {
        id: 'front_admin',
        name: 'Администратор'
      },
      {
        id: 'front_dep',
        name: 'Департамент ДЭ'
      },
      {
        id: 'front_education_ministry',
        name: 'Министерство просвещения РФ'
      },
      {
        id: 'front_me',
        name: 'Главный эксперт'
      },
      {
        id: 'front_tech_expert',
        name: 'Технический эксперт'
      },
      {
        id: 'front_le',
        name: 'Эксперт'
      },
      {
        id: 'front_mc',
        name: 'Менеджер профессий/специальностей (ДЭ)'
      },
      {
        id: 'front_rcc',
        name: 'Руководитель РО'
      },
      {
        id: 'front_mio',
        name: 'Мастер производственного обучения',
        permissions: {
        }
      },
      {
        id: 'front_50plus',
        name: 'Администратор 50+'
      },
      {
        id: 'front_curator',
        name: 'Куратор'
      },
      {
        id: 'front_assessor',
        name: 'Асессор'
      },
      {
        id: 'front_auditor',
        name: 'Аудитор'
      },
      {
        id: 'front_university',
        name: 'ВУЗ'
      },
      {
        id: 'front_curator_institution',
        name: 'Куратор ВУЗ'
      }
    ]
  },
  getRole (userGuid) {
    if (localStorage) {
      return localStorage.getItem(`role:${userGuid}`) || null
    }
    return null
  },
  setRole (userGuid, role) {
    if (localStorage) {
      localStorage.setItem(`role:${userGuid}`, role)
    }
  },
  removeRole (userGuid) {
    if (localStorage) {
      localStorage.removeItem(`role:${userGuid}`)
    }
  }
}

export { roleService }
